import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import logo from "@/assets/energieglueck-logo-white.png";
import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  const linkClass = "text-sm text-white/80 hover:text-primary transition-colors";

  return (
    <footer className="bg-ci-forest text-white">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          {/* KI-Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">KI-Services</h3>
            <ul className="space-y-2">
              <li><Link to="/ki" className={linkClass}>KI-Übersicht</Link></li>
              <li><Link to="/ki/reachy" className={linkClass}>Reachy KI-Assistent</Link></li>
              <li><Link to="/ki/projektmanagement" className={linkClass}>Projektmanagement</Link></li>
              <li><Link to="/ki/use-cases" className={linkClass}>Use Cases</Link></li>
              <li><Link to="/ki/playground" className={linkClass}>KI-Playground</Link></li>
            </ul>
          </div>

          {/* Batteriespeicher */}
          <div>
            <h3 className="text-lg font-bold mb-4">Batteriespeicher</h3>
            <ul className="space-y-2">
              <li><Link to="/gridstable" className={linkClass}>GridStable</Link></li>
              <li><Link to="/flaecheneigentuemer" className={linkClass}>{t('footer.landowners')}</Link></li>
              <li><Link to="/netzbetreiber" className={linkClass}>{t('footer.operators')}</Link></li>
              <li><Link to="/kommunen" className={linkClass}>{t('footer.municipalities')}</Link></li>
            </ul>
          </div>

          {/* Energieglück+ */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.platform')}</h3>
            <ul className="space-y-2">
              <li><Link to="/plattform" className={linkClass}>Übersicht</Link></li>
              <li><Link to="/plattform/anwendungen" className={linkClass}>Anwendungen</Link></li>
              <li><Link to="/plattform/wirtschaftlichkeit" className={linkClass}>Wirtschaftlichkeit</Link></li>
              <li><Link to="/plattform/referenzen" className={linkClass}>Referenzen</Link></li>
            </ul>
          </div>

          {/* Unternehmen */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.company')}</h3>
            <ul className="space-y-2">
              <li><Link to="/unternehmen/ueber-uns" className={linkClass}>{t('footer.about')}</Link></li>
              <li><Link to="/unternehmen/projekte" className={linkClass}>{t('footer.projects')}</Link></li>
              <li><Link to="/presse" className={linkClass}>{t('footer.press')}</Link></li>
            </ul>
          </div>

          {/* Service */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.service')}</h3>
            <ul className="space-y-2">
              <li><Link to="/kontakt" className={linkClass}>{t('footer.contact')}</Link></li>
              <li><Link to="/impressum" className={linkClass}>{t('footer.imprint')}</Link></li>
              <li><Link to="/datenschutz" className={linkClass}>{t('footer.privacy')}</Link></li>
            </ul>
          </div>

          {/* Kontakt-Block */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t('footer.contact')}</h3>
            <div className="space-y-3">
              <div className="flex items-center mb-2">
                <img src={logo} alt="Energieglück Gruppe" className="h-8" loading="lazy" />
              </div>
              <p className="text-sm font-semibold text-white/90">Energieglück Gruppe</p>
              <div className="text-sm text-white/80 space-y-1">
                <p>In der Gaß 7</p>
                <p>66557 Illingen</p>
                <p>Deutschland</p>
              </div>
              <div className="text-sm text-white/80">
                <p>info@energieglueck.de</p>
              </div>
              <a
                href="https://www.linkedin.com/company/energieglueck/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-white/10 hover:bg-primary transition-colors duration-300 mt-2"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4 text-white" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-sm text-white/60">
            {t('footer.copyright')} |{" "}
            <Link to="/impressum" className="hover:text-primary transition-colors">{t('footer.imprint')}</Link>
            {" · "}
            <Link to="/datenschutz" className="hover:text-primary transition-colors">{t('footer.privacy')}</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
